// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TradeInVehicle, Vehicle } from '@interfaces/vehicle.interfaces';
import { debounceTime, distinctUntilChanged, takeWhile } from 'rxjs';

@Component({
    selector: 'app-trade-in-form',
    templateUrl: './trade-in-form.component.html',
    styleUrls: ['./trade-in-form.component.scss'],
})
export class TradeInFormComponent implements OnInit, OnDestroy {
    @Input() required = false;
    @Input() vehicle: TradeInVehicle;
    @Output() updated = new EventEmitter();
    vehicleForm: FormGroup;

    private isComponentAlive = true;

    constructor(private fb: FormBuilder) {}

    ngOnInit() {
        this.buildForm();

        this.vehicleForm.valueChanges
            .pipe(
                takeWhile(() => this.isComponentAlive),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((val) => {
                this.updated.emit(val);
            });
    }

    buildForm() {
        this.vehicleForm = this.fb.group({
            vin: [
                this.vehicle?.vin ?? '',
                this.required ? Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(18)]) : undefined,
            ],
            bodyStyle: [this.vehicle?.bodyStyle ?? '', Validators.compose([Validators.maxLength(128)])],
            bodyType: [this.vehicle?.bodyType ?? ''],
            exteriorColor: [this.vehicle?.vehicleExt?.exteriorColor ?? ''],
            interiorColor: [this.vehicle?.vehicleExt?.interiorColor ?? ''],
            make: [this.vehicle?.make ?? ''],
            model: [this.vehicle?.model ?? ''],
            price: [this.vehicle?.vehicleExt?.priceInternet ?? ''],
            payoff: [this.vehicle?.payoff ?? ''],
            stockNumber: [this.vehicle?.stockNumber ?? '', this.required ? Validators.compose([Validators.required]) : undefined],
            year: [this.vehicle?.year ?? '', Validators.compose([Validators.min(1950), Validators.max(new Date().getFullYear())])],
            trim: [this.vehicle?.trim ?? ''],
        });
    }

    handleSubmit(event: any) {
        event.preventDefault();
    }

    ngOnDestroy() {
        this.isComponentAlive = false;
    }
}
